<template>
  <div class="quiz" @click="currentVideo = 100">
    <div class="panel__question" :class="[gameState]">
      <transition name="fade-like-background">
        <div v-show="gameState === 'showHome' || gameState === 'showEnd'" class="vw-logo">
          <div class="logo-wrapper">
            <VWLogo class="logo"></VWLogo>
          </div>
          <div class="line"></div>
        </div>
      </transition>
      <div v-if="gameState === 'showHome'" class="idle">
        <div class="title">How To Play</div>
        <div class="sub-title">Skee-Dub Trivia</div>
        <div class="desc">There are ten questions in this game.</div>
        <button @click="startGame">Start game</button>
      </div>
      <div v-else-if="gameState === 'showEnd'" class="idle">
        <div class="title">Thanks</div>
        <div class="sub-title">for playing!</div>
      </div>
      <div class="question-card" :key="questionIndex" v-else>
        <div class="title">Question {{ questionIndex }}</div>
        <div class="question">{{ questions[questionIndex].question }}</div>
        <div class="options">
          <div
            class="option"
            v-for="(option, key) in questions[questionIndex].options"
            :key="key"
            :class="{
              correctAnswer: showCorrectAnswer === key.toString(),
              wrongAnswer: showWrongAnswer === key.toString(),
            }"
            @click="verifyAnswer(key)"
          >
            <transition name="fade-fast">
              <div class="icon correct" v-show="showCorrectAnswer === key.toString()">
                <img src="@/assets/icons/correct-answer.svg?external" alt="" />
              </div>
            </transition>
            <transition name="fade-fast">
              <div class="icon wrong" v-show="showWrongAnswer === key.toString()">
                <img src="@/assets/icons/wrong-answer.svg?external" alt="" />
              </div>
            </transition>
            <span class="text--uppercase">{{ key }}.</span> {{ option }}
          </div>
        </div>
        <button class="next-button" :disabled="gameState !== 'showPoints'" @click="nextQuestion">
          Next Question
        </button>
      </div>
    </div>
    <div
      class="panel__video"
      :class="[gameState === 'showQuestion' || gameState === 'showPoints' ? 'question' : 'idle']"
    >
      <img src="@/assets/images/vw_skeeball_bright-overlay.jpg" class="baseImage" alt="" />
      <transition-group name="fade" mode="in-out">
        <div class="video-wrapper" v-show="gameState === 'showQuestion'" key="videoWrapper">
          <video v-show="videoState === 'video10'" ref="video10" key="video10" preload="auto" :muted="isMuted">
            <source :src="videos['10']" type="video/mp4" />
          </video>
          <video v-show="videoState === 'video100'" ref="video100" key="video100" preload="auto" :muted="isMuted">
            <source :src="videos['100']" type="video/mp4" />
          </video>
          <audio src="@/assets/audio/arcade-sounds.mp3" preload="auto" ref="audioIdle" :muted="isMuted" loop></audio>
          <video v-show="videoState === 'videoIdle'" ref="videoIdle" key="videoIdle" preload="auto" muted loop>
            <source :src="videos['idle']" type="video/mp4" />
          </video>
        </div>
        <img
          v-show="gameState === 'showHome' || gameState === 'showEnd'"
          src="@/assets/images/vw_skeeball_bright-overlay.jpg"
          alt=""
          key="overlayBright"
        />
        <div class="points" v-show="gameState === 'showPoints'" key="points">
          <div class="text1">You Scored</div>
          <div class="text2">{{ pointsEarned }} points</div>
          <div class="text3">Total: {{ pointsTotal }}</div>
        </div>
        <img
          v-show="gameState === 'showPoints'"
          src="@/assets/images/vw_skeeball_dark-overlay.jpg"
          alt=""
          key="overlayDark"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import VWLogo from '@/assets/icons/vw-logo-white.svg';

export default {
  components: {
    VWLogo,
  },
  data() {
    return {
      gameState: 'showHome',
      videoState: null,
      questionIndex: 1,
      currentVideo: 'idle',
      pointsEarned: 0,
      pointsTotal: 0,
      showAnswer: null,
      showPointsEarned: false,
      showCorrectAnswer: null,
      showWrongAnswer: null,
      videoIsPlaying: false,
      isMuted: true,
      videos: {
        idle: require('@/assets/videos/VW_Skeeball_091120_enc-cs.mp4'),
        10: require('@/assets/videos/VW_Skeeball_10pts_091120_enc-cs.mp4'),
        // 20: require('@/assets/videos/VW_Skeeball_20pts_091120_enc-cs.mp4'),
        // 30: require('@/assets/videos/VW_Skeeball_30pts_091120_enc-cs.mp4'),
        // 40: require('@/assets/videos/VW_Skeeball_40pts_091120_enc-cs.mp4'),
        // 50: require('@/assets/videos/VW_Skeeball_50pts_091120_enc-cs.mp4'),
        100: require('@/assets/videos/VW_Skeeball_100pts_091120_enc-cs.mp4'),
      },
      minPoints: 10,
      questions: {
        1: {
          question: 'In each step of battery production, Volkswagen keeps what in mind?',
          options: {
            a: 'Convenience',
            b: 'Speed of assembly',
            c: 'CO2 reduction',
            d: 'Convenience of transport',
          },
          correctAnswer: 'c',
          maxPoints: 100,
        },
        2: {
          question:
            'Using green electricity in battery production reduces CO2 emissions in this phase of the ID. assembly by how much?',
          options: {
            a: '60%',
            b: '80%',
            c: '37%',
            d: '85%',
          },
          correctAnswer: 'b',
          maxPoints: 100,
        },
        3: {
          question: 'True or false, the most cost effective time to charge your EV is during Peak Time.',
          options: {
            a: 'True',
            b: 'False',
          },
          correctAnswer: 'b',
          maxPoints: 100,
        },
        4: {
          question: 'V2G Stands for:',
          options: {
            a: 'Vehicle to Grid',
            b: 'Volkswagen Technische Größe (Technical Greatness)',
            c: 'Vehicle Tüchtigkeit Größe (Efficiency Greatness)',
            d: 'None of the above',
          },
          correctAnswer: 'a',
          maxPoints: 100,
        },
        5: {
          question:
            'True or false, the ID.4 battery will be warranted against defect in material and workmanship and net capacity loss below 70% for 8years/100,000 miles',
          options: {
            a: 'True',
            b: 'False',
          },
          correctAnswer: 'a',
          maxPoints: 100,
        },
        6: {
          question:
            'This component of the battery makes the most efficient use of space and achieves a 90 to 95 percent packaging efficiency',
          options: {
            a: 'Connector Strip',
            b: 'Cell Management Controller',
            c: 'Module Cell',
            d: 'Drive Matrix',
          },
          correctAnswer: 'c',
          maxPoints: 100,
        },
        7: {
          question:
            'This component is the channel through which power is sent during charging, and pulled through when being sent to the motors for driving power',
          options: {
            a: 'Connector Strip',
            b: 'Cell Management Controller',
            c: 'Module Cell',
            d: 'Thermal Management System',
          },
          correctAnswer: 'a',
          maxPoints: 100,
        },
        8: {
          question: 'True or False, In the future, EVs could actually strengthen the electrical grid.',
          options: {
            a: 'True',
            b: 'False',
          },
          correctAnswer: 'a',
          maxPoints: 100,
        },
        9: {
          question: 'When a battery has reached the end of its usefulness in a vehicle, it could :',
          options: {
            a: 'Be utilized as a component in a quick charging station',
            b: 'Be recycled in a process that will strip the valuable raw materials for reuse in new batteries',
            c: 'Either a or b',
            d: 'Neither a nor b',
          },
          correctAnswer: 'c',
          maxPoints: 100,
        },
        10: {
          question:
            'True or false, the Cell Management Controller ensures battery cells within each module maintain balanced levels while driving and charging.',
          options: {
            a: 'True',
            b: 'False',
          },
          correctAnswer: 'a',
          maxPoints: 100,
        },
      },
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.questionIndex];
    },
  },
  mounted() {
    document.body.classList.add('idle');
  },
  methods: {
    startGame() {
      this.gameState = 'showQuestion';
      this.videoState = 'videoIdle';
      this.$refs.videoIdle.currentTime = 0;
      this.$refs.videoIdle.play();
      this.$refs.audioIdle.volume = 0.07;
      this.$refs.audioIdle.play();
      document.body.classList.remove('idle');
      document.body.classList.add('question');
      this.isMuted = false;
    },
    nextQuestion() {
      this.questionIndex += 1;
      if (this.questionIndex > Object.keys(this.questions).length) {
        this.gameState = 'showEnd';
        document.body.classList.remove('question');
        document.body.classList.add('idle');
      } else {
        this.gameState = 'showQuestion';
        this.videoState = 'videoIdle';
        this.showCorrectAnswer = null;
        this.showWrongAnswer = null;
      }
    },
    verifyAnswer(answer) {
      if (this.gameState !== 'showQuestion' || this.videoIsPlaying) return;
      if (this.currentQuestion.correctAnswer === answer.toString()) {
        this.showCorrectAnswer = answer;
        this.show100();
      } else {
        this.showCorrectAnswer = this.currentQuestion.correctAnswer;
        this.showWrongAnswer = answer;
        this.show10();
      }
    },
    show10() {
      this.videoState = 'video10';
      this.$refs.video10.currentTime = 0;
      this.$refs.video10.play();
      this.videoIsPlaying = true;
      this.$refs.video10.onended = () => {
        this.pointsEarned = 10;
        this.pointsTotal += this.pointsEarned;
        this.gameState = 'showPoints';
        this.videoIsPlaying = false;
      };
    },
    show100() {
      this.videoState = 'video100';
      this.$refs.video100.currentTime = 0;
      this.$refs.video100.play();
      this.videoIsPlaying = true;
      this.$refs.video100.onended = () => {
        this.pointsEarned = 100;
        this.pointsTotal += this.pointsEarned;
        this.gameState = 'showPoints';
        this.videoIsPlaying = false;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin for-small-phone-only {
  @media (max-width: 449px) {
    @content;
  }
}
@mixin for-phone-only {
  @media (max-width: 599px) {
    @content;
  }
}
@mixin for-tablet-only {
  @media (max-width: 959px) {
    @content;
  }
}
@mixin for-large-tablet-only {
  @media (max-width: 1267px) {
    @content;
  }
}
@mixin for-small-desktop-only {
  @media (max-width: 1496px) {
    @content;
  }
}
$color1: #001e50;
$color2: #ffffff;
$color3: #00b0f0;
$color4: #ff335c;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity ease-in 0.25s;
}
.fade-fast-enter, .fade-fast-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-like-background-enter-active {
  transition: opacity ease-in 0.35s;
}
.fade-like-background-enter, .fade-like-background-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.text {
  &--uppercase {
    text-transform: uppercase;
  }
}
.quiz {
  display: flex;
  width: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;

  @include for-tablet-only {
    position: relative;
    height: 100vh;
    flex-direction: column;
  }
}
.panel {
  &__question {
    display: flex;
    flex-direction: column;
    width: 50%;
    // padding: 92px 119px;
    // padding: 50px;
    // padding-left: 92px;
    background-color: $color3;
    overflow: auto;
    // height: 100vh;
    color: $color2;
    transition: background-color ease-out 0.25s;
    @include for-tablet-only {
      height: 50%;
      width: 100%;
    }

    .vw-logo {
      // position: absolute;
      // visibility: hidden;
      // background-color: $color3;
      position: relative;
      margin-top: 47px;
      @include for-small-desktop-only {
        margin-top: 20px;
      }
      @include for-phone-only {
        margin-top: 5px;
      }
      background-color: $color1;
      &.showHome,
      &.showEnd {
        // transition: background-color ease-out 0.25s;
        // visibility: visible;
      }
      .logo {
        position: relative;
        width: 200px;
        background-color: $color3;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;

        @include for-small-desktop-only {
          width: 150px;
        }
        @include for-phone-only {
          width: 100px;
        }

        background-color: $color1;
        &.showHome,
        &.showEnd {
        }
      }
      .line {
        width: 100%;
        height: 2px;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &.showHome {
      background-color: $color1;
    }
    &.showEnd {
      background-color: $color1;
    }

    .idle {
      flex: 1;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      margin-top: 20px;
      padding-left: 92px;
      padding-right: 50px;
      padding-bottom: 50px;

      @include for-large-tablet-only {
        margin-top: 0;
        padding: 25px;
        padding-top: 0;
      }
      // margin-bottom: 50px;
    }
    .question-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: 685px;
      padding-top: 92px;
      padding-left: 92px;
      padding-right: 50px;
      padding-bottom: 50px;

      @include for-small-desktop-only {
        padding-top: 30px;
        padding-left: 50px;
      }
      @include for-large-tablet-only {
        padding-top: 30px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 30px;
      }
      @include for-phone-only {
        padding-top: 20px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
      }
    }
    .title {
      font-size: 73.85px;
      line-height: 88.62px;
      // font-size: 3.846vw;
      // line-height: 1.205em;
      font-weight: bold;

      @include for-small-desktop-only {
        font-size: 60px;
        line-height: 75px;
      }
      @include for-large-tablet-only {
        font-size: 46px;
        line-height: 60px;
      }
      @include for-phone-only {
        font-size: 40px;
        line-height: 50px;
      }
    }
    .sub-title {
      font-size: 73.85px;
      line-height: 88.62px;
      // font-size: 3.846vw;
      // line-height: 1.205em;
      font-weight: 300;
      @include for-phone-only {
        font-size: 40px;
        line-height: 49px;
      }
    }

    .desc {
      margin-top: 30px;
      font-size: 40px;
      line-height: 60px;
      margin-bottom: auto;
      @include for-phone-only {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .question {
      font-family: 'VW Text';
      margin-top: 50px;
      margin-bottom: 31px;
      font-size: 34px;
      line-height: 43px;
      // font-size: 1.25vw;
      // line-height: 1.792em;

      @include for-small-desktop-only {
        margin-top: 30px;
        font-size: 25px;
        line-height: 40px;
      }
      @include for-large-tablet-only {
        margin-top: 30px;
        font-size: 23px;
        line-height: 31px;
      }
      @include for-phone-only {
        font-size: 16px;
        line-height: 25px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }

    .options {
      transition: margin ease 0.2s;
      margin: auto 0;
      margin-left: -8%;
      @include for-small-desktop-only {
        margin-left: -3%;
      }
      @include for-large-tablet-only {
        margin-left: 0%;
      }
      @include for-phone-only {
        margin-left: -5%;
      }

      .option {
        position: relative;
        padding: 19px 0;
        font-size: 24px;
        // font-size: 1.25vw;
        cursor: pointer;
        padding-left: 75px;

        @include for-small-desktop-only {
          font-size: 20px;
        }
        @include for-large-tablet-only {
          font-size: 20px;
          padding-top: 12px;
          padding-bottom: 12px;
        }
        @include for-phone-only {
          padding: 5px 0;
          padding-left: 30px;
          font-size: 16px;
          line-height: 25px;
        }

        .icon {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          padding: 0px 22px;
          display: flex;
          justify-content: center;
          align-items: center;

          @include for-phone-only {
            padding: 9px;
          }
          img {
            @include for-phone-only {
              width: 12px;
            }
          }

          &.correct {
            // background-color: $color1;
          }
          &.wrong {
            // background-color: $color4;
          }
        }

        &:not(:first-of-type) {
          margin-top: 11px;
        }

        transition: background-color ease-in 0.25s;
        &.correctAnswer {
          background-color: $color1;
        }
        &.wrongAnswer {
          background-color: $color4;
        }

        &::after {
          content: '';
        }
      }
    }
  }
  &__video {
    width: 50%;
    background-color: $color2;
    position: relative;
    // height: 100vh;
    @include for-tablet-only {
      height: 50%;
      width: 100%;
    }

    &.idle {
      background-color: $color1;
    }
    &.question {
      background-color: $color3;
    }
    img,
    .video-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
    img,
    video {
      width: 100%;
      display: block;
    }
    .points {
      position: absolute;
      left: 8%;
      top: 13%;
      color: #fff;
      z-index: 999;
      @include for-phone-only {
        // left: 90px;
        // top: 128px;
      }

      .text1 {
        font-family: 'VW Head';
        font-size: 73.85px;
        font-weight: 300;
        line-height: 88.26px;
        @include for-phone-only {
          font-size: 40px;
          line-height: 50px;
        }
      }
      .text2 {
        font-family: 'VW Head';
        font-size: 73.85px;
        font-weight: bold;
        line-height: 88.26px;
        @include for-phone-only {
          font-size: 40px;
          line-height: 50px;
        }
      }
      .text3 {
        margin-top: 50px;
        font-family: 'VW Head';
        font-size: 45px;
        font-weight: bold;
        line-height: 55px;
        @include for-phone-only {
          margin-top: 30px;
          font-size: 23px;
          line-height: 40px;
        }
      }
    }
    .baseImage {
      position: relative;
    }
  }
}
button {
  flex-shrink: 0;
  background: none;
  background-color: $color2;
  margin-top: 50px;
  // margin-bottom: 50px;
  color: $color1;
  font-size: 19px;
  width: 205px;
  height: 60px;
  border-radius: 30px;
  border: none;
  cursor: pointer;

  @include for-tablet-only {
    // width: 305px;
  }
  @include for-tablet-only {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }
  @include for-phone-only {
    bottom: 20px;
    width: 100%;
    max-width: 195px;
    height: 45px;
    font-size: 16px;
  }
  transition: opacity ease-in 0.25s;
  opacity: 1;
  &:disabled {
    opacity: 0;
  }

  &.next-button {
    margin-top: 50px;
    @include for-large-tablet-only {
      margin-top: 20px;
    }
  }
}
</style>
